const SkeletonLoader = () => {
    const skeletonStyle = {
      position: 'relative',
      display: 'block',
      backgroundColor: '#e5e7eb', // equivalent to bg-gray-200
      borderRadius: '0.5rem', // rounded-lg
      overflow: 'hidden',
    };
  
    const shimmerStyle = {
      position: 'absolute',
      inset: 0,
      transform: 'translateX(-100%)',
      animation: 'shimmer 3s infinite',
      backgroundImage: 'linear-gradient(to right, transparent, #f9fafb, transparent)', // equivalent to before:bg-gradient-to-r
    };
  
    return (
      <div
        style={{
          marginTop: '3rem', // my-12
          borderRadius: '0.5rem', // rounded-lg
          border: '1px solid #d1d5db', // border
          backgroundColor: '#ffffff', // bg-white
        }}
      >
        <div style={{ padding: '1rem' }}>
          <span style={{ ...skeletonStyle, height: '1.5rem', marginBottom: '1rem' }}>
            <span style={shimmerStyle}></span>
          </span>
          <span style={{ ...skeletonStyle, height: '1.5rem' }}>
            <span style={shimmerStyle}></span>
          </span>
        </div>
        <hr />
        <div style={{ padding: '1rem 1rem 0' }}>
          <div style={{ ...skeletonStyle, height: '1rem' }}>
            <span style={shimmerStyle}></span>
          </div>
        </div>
        <div style={{ padding: '1rem' }}>
          <div style={{ ...skeletonStyle, height: '1rem', width: '60%', margin: '1rem 0' }}>
            <span style={shimmerStyle}></span>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1rem', // gap-4
              paddingTop: '1.5rem', // py-6
              paddingBottom: '1.5rem',
            }}
          >
            {[...Array(6)].map((_, i) => (
              <span
                key={i}
                style={{
                  ...skeletonStyle,
                  height: '1rem',
                  gridColumn: i % 2 === 1 ? 'span 2' : 'span 1',
                }}
              >
                <span style={shimmerStyle}></span>
              </span>
            ))}
          </div>
          <div style={{ ...skeletonStyle, height: '1rem', width: '60%', margin: '1rem 0' }}>
            <span style={shimmerStyle}></span>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1rem', // gap-4
              paddingTop: '1.5rem', // py-6
              paddingBottom: '1.5rem',
            }}
          >
            {[...Array(6)].map((_, i) => (
              <span
                key={i}
                style={{
                  ...skeletonStyle,
                  height: '1rem',
                  gridColumn: i % 2 === 1 ? 'span 2' : 'span 1',
                }}
              >
                <span style={shimmerStyle}></span>
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  };
  
  export default SkeletonLoader;
  